import { Component, computed, inject } from "@angular/core"
import { IntroService } from "../intro.service"
import { RouteService } from "../../../../services/route.service"
import { UiDialogComponent } from "ui-dialog"
import { NgOptimizedImage } from "@angular/common"
import { PageToolbarService } from "../../../page-toolbar.service"
import { UiInheritDirective } from "ui-inherit"
import { StorageService } from "../../../../services/storage.service"

@Component({
  imports: [
    UiInheritDirective,
    UiDialogComponent,
    NgOptimizedImage,
  ],
  standalone: true,
  template: `
    @if (!!grade()) {
      <lib-ui-dialog (cancelAndClose)="hide()" [offset]="pageToolbarHeight() + 10">
        <div ngProjectAs="title">
          {{ grade()?.title }}
        </div>

        <div ngProjectAs="content">
          @let data = grade();
          @if (data) {
            <div class="flex gap-5 flex-wrap">
              <div class=" column flex-1 min-w-[300px] gap-2.5 p-2.5">
                <div class="relative overflow-hidden">
                  <div class="absolute top-0 -right-12 w-48 h-48 -rotate-12">
                    <img
                      [ngSrc]="imageMapMapSrc()"
                      [alt]="data.imageMap.altText"
                      style="width: 60%; position: relative"
                      fill=""
                    >
                  </div>
                  <div class="p-8 rotate-12">
                    <img
                      [ngSrc]="imagePictureSrc()"
                      [alt]="data.imagePicture.altText"
                      style="width: 60%; position: relative"
                      fill=""
                    >
                  </div>
                </div>
                @for (copy of data.copyArray; track index; let index = $index) {
                  <div>
                    {{ copy }}
                  </div>
                }
              </div>
              <div
                style="aspect-ratio: 9/16"
                class="flex-1 min-w-[300px] relative"
              >
                <img
                  [ngSrc]="imageDescriptionSrc()"
                  [alt]="data.imageDescription.altText"
                  style="position: relative"
                  class="object-contain"
                  fill
                >
              </div>
            </div>
          }
        </div>

      </lib-ui-dialog>
    }
  `,
  selector: "e2e-grade-modal",
})
export class GradeModalComponent {
  private routeService = inject(RouteService)
  private introService = inject(IntroService)
  private pageToolbarService = inject(PageToolbarService)
  private storageService = inject(StorageService)

  pageToolbarHeight = this.pageToolbarService.pageToolbarHeight

  fragments = this.introService.fragments
  grades = this.introService.grades
  grade = computed(() =>
    this.grades().find((grade) => grade.grade === this.fragments()[0].toUpperCase())
  )

  imageMapMapSrc = computed(() => {
      return this.storageService.getFileUrl(this.grade()?.imageMap.map_src)
    }
  )
  imagePictureSrc = computed(() =>
    this.storageService.getFileUrl(this.grade()?.imagePicture.src)
  )
  imageDescriptionSrc = computed(() =>
    this.storageService.getFileUrl(this.grade()?.imageDescription.src)
  )

  hide() {
    this.routeService.changeRoute([])
  }

}
